import { createContext } from "react";

const appContextStore = createContext(); // main
const lookupsContext = createContext(); // lookupsContext

export { appContextStore, lookupsContext };
